export default __webpack_public_path__ + "static/media/Ballroll_00111.e1ee837e.png";